import React from "react";
import { MdZoomIn } from "react-icons/md";

const ZoomButton = ({
  onClick,
  modalTarget,
  size = "md", // "sm", "md", "lg"
  className = "",
  positionClasses = "absolute bottom-1.5 right-1.5",
  ariaLabel = "Zoom image",
}) => {
  // Determine width and height classes based on size prop
  let sizeClasses = "w-5 h-5";

  if (size === "sm") {
    sizeClasses = "w-4 h-4";
  } else if (size === "lg") {
    sizeClasses = "w-6 h-6";
  }

  const handleZoomClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      type="button"
      className={`${positionClasses} z-10 ${sizeClasses} max-[640px]:w-4 max-[640px]:h-4 rounded-full bg-white text-slate-700 flex items-center justify-center shadow-[0_2px_8px_rgba(0,0,0,0.08)] hover:scale-105 active:scale-95 transition-all border border-outline/50 cursor-pointer focus:outline-none ${className}`}
      {...(modalTarget && window.innerWidth >= 768 ? { "data-bs-toggle": "modal", "data-bs-target": modalTarget } : {})}
      onClick={handleZoomClick}
      aria-label={ariaLabel}
    >
      <MdZoomIn
        className="shrink-0 max-[640px]:!w-2.5 max-[640px]:!h-2.5"
        size={size === "lg" ? 14 : size === "sm" ? 11 : 12}
      />
    </button>
  );
};

export default ZoomButton;
